<div class="header-bar">
  <h1>Engineius Tasks Report</h1>
</div>
<div class="">
  <div class="">
    <div class="content-container">
      <div class="ui-g-12">
        <form (ngSubmit)="search()" style="width: 100%">
          <div class="ui-g filterPanel">
            <div class="ui-g-12 ui-md-4 ui-lg-2">
              <span class="md-inputfield filterItem">
                <p-calendar
                  [(ngModel)]="filterVal.filters.pickUpDateFrom.value"
                  name="createDateTo"
                  dateFormat="dd/mm/yy"
                ></p-calendar>
                <label>Pick Up Date From</label>
              </span>
            </div>

            <div class="ui-g-12 ui-md-4 ui-lg-2">
              <span class="md-inputfield filterItem">
                <p-calendar
                  [(ngModel)]="filterVal.filters.pickUpDateTo.value"
                  name="createDateTo"
                  dateFormat="dd/mm/yy"
                ></p-calendar>
                <label>Pick Up Date To</label>
              </span>
            </div>

            <div class="ui-g-12 ui-md-4 ui-lg-2">
              <span class="md-inputfield filterItem">
                <p-calendar
                  [(ngModel)]="filterVal.filters.completedDateFrom.value"
                  name="createDateTo"
                  dateFormat="dd/mm/yy"
                ></p-calendar>
                <label>Completed Date From</label>
              </span>
            </div>

            <div class="ui-g-12 ui-md-4 ui-lg-2">
              <span class="md-inputfield filterItem">
                <p-calendar
                  [(ngModel)]="filterVal.filters.completedDateTo.value"
                  name="createDateTo"
                  dateFormat="dd/mm/yy"
                ></p-calendar>
                <label>Completed Date To</label>
              </span>
            </div>

            <div class="ui-g-12 ui-md-4 ui-lg-4">
              <div class="ui-g-3">
                <label>Movement Type</label>
              </div>
              <div class="ui-g-9">
                <p-dropdown
                  [options]="taskTypes"
                  autoWidth="false"
                  [style]="{ width: '100%' }"
                  [(ngModel)]="filterVal.filters.type.value"
                  name="type"
                ></p-dropdown>
              </div>
            </div>

            <div class="ui-g-12 ui-md-4 ui-lg-4">
              <div class="ui-g-3">
                <label>Customer</label>
              </div>
              <div class="ui-g-9">
                <p-dropdown
                  [options]="customers"
                  autoWidth="false"
                  [style]="{ width: '100%' }"
                  filter="true"
                  [(ngModel)]="filterVal.filters.customer.value"
                  name="customer"
                ></p-dropdown>
              </div>
            </div>

            <div class="ui-g-12 ui-md-4 ui-lg-4">
              <div class="ui-g-3">
                <label>Supplier</label>
              </div>
              <div class="ui-g-9">
                <p-dropdown
                  [options]="suppliers"
                  autoWidth="false"
                  [style]="{ width: '100%' }"
                  filter="true"
                  [(ngModel)]="filterVal.filters.supplier.value"
                  name="supplier"
                ></p-dropdown>
              </div>
            </div>

            <div class="ui-g-12 ui-md-4 ui-lg-4">
              <div class="ui-g-3">
                <label>Status</label>
              </div>
              <div class="ui-g-9">
                <p-multiSelect
                  [options]="orderStatuses"
                  autoWidth="false"
                  [style]="{ width: '100%' }"
                  [(ngModel)]="filterVal.filters.status.value"
                  name="status"
                ></p-multiSelect>
              </div>
            </div>

            <div class="ui-g-12">
              <button
                pButton
                type="button"
                label="Clear"
                class="ui-button btn-to-right"
                (click)="clearFilter(dt)"
              ></button>
              <button pButton type="submit" label="Search" class="ui-button btn-to-right"></button>
            </div>
          </div>
        </form>

        <p-table
          #dt
          selectionMode="single"
          [value]="page.items"
          [lazy]="true"
          [rows]="10"
          [paginator]="true"
          rowHover="true"
          [resizableColumns]="true"
          [totalRecords]="page.total"
          (onLazyLoad)="onGridLazyLoad($event)"
          [loading]="isLoading"
          [rowsPerPageOptions]="[5, 10, 20]"
          [pageLinks]="3"
          (onSort)="changeSort($event)"
        >
          <ng-template pTemplate="header">
            <tr class="no-wrap-cells cells-overflow-hidden">
              <th style="width: 130px" pResizableColumn pSortableColumn="jobNumber">Job No</th>
              <th style="width: 130px" pResizableColumn pSortableColumn="orderNumber">Order No</th>
              <th style="width: 130px" pResizableColumn pSortableColumn="lastPickUp">
                Last Pick Up
              </th>
              <th style="width: 130px" pResizableColumn pSortableColumn="lastDropOff">
                Last Drop Off
              </th>
              <th style="width: 130px" pResizableColumn pSortableColumn="completedDateTime">
                Completed Date/time
              </th>
              <th style="width: 130px" pResizableColumn pSortableColumn="from">Postcode From</th>
              <th style="width: 130px" pResizableColumn pSortableColumn="to">Postcode To</th>
              <th style="width: 130px" pResizableColumn pSortableColumn="movementType">
                Movement Type
              </th>
              <th style="width: 130px" pResizableColumn pSortableColumn="vehicle">Vehicle</th>
              <th style="width: 130px" pResizableColumn pSortableColumn="regNumber">Reg Plate</th>
              <th style="width: 130px" pResizableColumn pSortableColumn="kerbWeight">
                Vehicle Weight
              </th>
              <th style="width: 130px" pResizableColumn pSortableColumn="status">Status</th>
              <th style="width: 130px" pResizableColumn pSortableColumn="costCodes">Cost Code</th>
              <th style="width: 130px" pResizableColumn pSortableColumn="tags">Tags</th>
              <th style="width: 130px" pResizableColumn pSortableColumn="distance">Mileage</th>
              <th style="width: 130px" pResizableColumn pSortableColumn="travelTime">
                Travel Time
              </th>
              <th style="width: 130px" pResizableColumn pSortableColumn="customerName">Customer</th>
              <th style="width: 130px" pResizableColumn pSortableColumn="amountMin">
                Customer Amt Min
              </th>
              <th style="width: 130px" pResizableColumn pSortableColumn="amountMax">
                Customer Amt Max
              </th>
              <th style="width: 130px" pResizableColumn pSortableColumn="amountFinal">
                Customer Amt Final
              </th>
              <th style="width: 130px" pResizableColumn pSortableColumn="supplierMovementAmount">
                Supplier
              </th>
              <th style="width: 130px" pResizableColumn pSortableColumn="supplierFinalAmount">
                Supplier Amt Final
              </th>
            </tr>
          </ng-template>
          <ng-template pTemplate="body" let-item>
            <tr [pSelectableRow]="item" class="no-wrap-cells cells-overflow-hidden">
              <td>{{ item.jobNumber }}</td>
              <td>{{ item.orderNumber }}</td>
              <td>
                <span>{{ item.lastPickUp | datex : "ddd DD MMM 'YY HH:mm" }}</span>
              </td>
              <td>
                <span>{{ item.lastDropOff | datex : "ddd DD MMM 'YY HH:mm" }}</span>
              </td>
              <td>
                <span>{{ item.completedDateTime | datex : "ddd DD MMM 'YY HH:mm" }}</span>
              </td>
              <td>{{ item.from }}</td>
              <td>{{ item.to }}</td>
              <td>{{ item.movementType }}</td>
              <td>{{ item.vehicle }}</td>
              <td>{{ item.regNumber }}</td>
              <td>{{ item.kerbWeight }}</td>
              <td>{{ item.status }}</td>
              <td>{{ item.costCodes }}</td>
              <td>{{ item.tags }}</td>
              <td>{{ item.distance }}</td>
              <td>{{ item.travelTime }}</td>
              <td>{{ item.customerName }}</td>
              <td>
                <span>{{ item.amountMin | currency : 'GBP' : 'symbol' : '1.2-2' }}</span>
              </td>
              <td>
                <span>{{ item.amountMax | currency : 'GBP' : 'symbol' : '1.2-2' }}</span>
              </td>
              <td>
                <span>{{ item.amountFinal | currency : 'GBP' : 'symbol' : '1.2-2' }}</span>
              </td>
              <td>
                <span>{{
                  item.supplierMovementAmount | currency : 'GBP' : 'symbol' : '1.2-2'
                }}</span>
              </td>
              <td>
                <span>{{ item.supplierFinalAmount | currency : 'GBP' : 'symbol' : '1.2-2' }}</span>
              </td>
            </tr>
          </ng-template>
        </p-table>

        <!--- DATATABLE DEPRECATED ---

                <p-dataTabl #dt
                             selectionMode="single"
                             [value]="page.items"
                             [lazy]="true"
                             [rows]="10"
                             [responsive]="true"
                             [paginator]="true"
                             rowHover="true"
                             resizableColumns="true"
                             [totalRecords]="page.total"
                             (onLazyLoad)="onGridLazyLoad($event)"
                             [loading]="isLoading"
                             [rowsPerPageOptions]="[5,10,20]"
                             [pageLinks]="3"
                             (onSort)="changeSort($event)"
                             [scrollable]="true">

                    <p-column field="jobNumber" header="Job No" [sortable]="tru" [style]="{'width':'130px'}"></p-column>
                    <p-column field="orderNumber" header="Order No" [sortable]="tru" [style]="{'width':'130px'}"></p-column>
                    <p-column field="lastPickUp" header="Last Pick Up" [sortable]="tru"
                              [style]="{'width':'130px'}">
                        <ng-template let-col let-order="rowData" pTemplate="body">
                            <span>{{ order[col.field] | datex:'ddd DD MMM \'YY HH:mm' }}</span>
                        </ng-template>
                    </p-column>
                    <p-column field="lastDropOff" header="Last Drop Off" [sortable]="tru"
                              [style]="{'width':'130px'}">
                        <ng-template let-col let-order="rowData" pTemplate="body">
                            <span>{{ order[col.field] | datex:'ddd DD MMM \'YY HH:mm' }}</span>
                        </ng-template>
                    </p-column>
                    <p-column field="completedDateTime" header="Completed Date/time" [sortable]="tru"
                              [style]="{'width':'130px'}">
                        <ng-template let-col let-order="rowData" pTemplate="body">
                            <span>{{ order[col.field] | datex:'ddd DD MMM \'YY HH:mm' }}</span>
                        </ng-template>
                    </p-column>
                    <p-column field="from" header="Postcode From" [sortable]="tru" [style]="{'width':'130px'}"></p-column>
                    <p-column field="to" header="Postcode To" [sortable]="tru" [style]="{'width':'130px'}"></p-column>
                    <p-column field="movementType" header="Movement Type" [sortable]="tru" [style]="{'width':'130px'}"></p-column>
                    <p-column field="vehicle" header="Vehicle" [sortable]="tru" [style]="{'width':'130px'}"></p-column>
                    <p-column field="regNumber" header="Reg Plate" [sortable]="tru" [style]="{'width':'130px'}"></p-column>
                    <p-column field="kerbWeight" header="Vehicle Weight" [sortable]="tru" [style]="{'width':'130px'}"></p-column>
                    <p-column field="status" header="Status" [sortable]="tru" [style]="{'width':'130px'}"></p-column>
                    <p-column field="costCodes" header="Cost Code" [sortable]="tru" [style]="{'width':'130px'}"></p-column>
                    <p-column field="tags" header="Tags" [sortable]="tru" [style]="{'width':'130px'}"></p-column>
                    <p-column field="distance" header="Mileage" [sortable]="tru" [style]="{'width':'130px'}"></p-column>
                    <p-column field="travelTime" header="Travel Time" [sortable]="tru" [style]="{'width':'130px'}"></p-column>
                    <p-column field="customerName" header="Customer" [sortable]="tru" [style]="{'width':'130px'}"></p-column>
                    <p-column field="amountMin" header="Customer Amount Min" [sortable]="tru" [style]="{'width':'130px'}">
                        <ng-template let-order="rowData" pTemplate="body">
                            <span>{{ order.amountMin | currency:'GBP':'symbol':'1.2-2' }}</span>
                        </ng-template>
                    </p-column>
                    <p-column field="amountMax" header="Customer Amount Max" [sortable]="tru" [style]="{'width':'130px'}">
                        <ng-template let-order="rowData" pTemplate="body">
                            <span>{{ order.amountMax | currency:'GBP':'symbol':'1.2-2' }}</span>
                        </ng-template>
                    </p-column>
                    <p-column field="amountFinal" header="Customer Amount Final" [sortable]="tru" [style]="{'width':'130px'}">
                        <ng-template let-order="rowData" pTemplate="body">
                            <span>{{ order.amountFinal | currency:'GBP':'symbol':'1.2-2' }}</span>
                        </ng-template>
                    </p-column>
                    <p-column field="supplierName" header="Supplier" [sortable]="tru" [style]="{'width':'130px'}"></p-column>
                    <p-column field="supplierMovementAmount" header="Supplier Movement Amount" [sortable]="false" [style]="{'width':'130px'}">
                        <ng-template let-order="rowData" pTemplate="body">
                            <span>{{ order.supplierMovementAmount | currency:'GBP':'symbol':'1.2-2' }}</span>
                        </ng-template>
                    </p-column>
                    <p-column field="supplierFinalAmount" header="Supplier Final Amount" [sortable]="false" [style]="{'width':'130px'}">
                        <ng-template let-order="rowData" pTemplate="body">
                            <span>{{ order.supplierFinalAmount | currency:'GBP':'symbol':'1.2-2' }}</span>
                        </ng-template>
                    </p-column>

                </p-dataTable>

                --->
      </div>
      <div class="ui-g-12" style="height: 40px; margin-top: 20px">
        <button
          type="button"
          pButton
          icon="fa ui-icon-file-download"
          label="Download"
          class="ui-button btn-to-right"
          (click)="downloadReport()"
          [disabled]="page.total == 0"
        ></button>
      </div>
    </div>
  </div>
</div>
<ng-template #loading>Loading...</ng-template>
